import { Link } from "react-router-dom";
import { Mail, MapPin, ArrowUpRight } from "lucide-react";
import { SITE, CATEGORIES, waUrl, WA_GENERAL } from "../config/site";
import WhatsAppIcon from "./WhatsAppIcon";

export default function Footer() {
  return (
    <footer className="bg-obsidian text-white" data-testid="site-footer">
      <div className="container-site grid gap-12 py-16 lg:grid-cols-12 lg:py-20">
        <div className="lg:col-span-4">
          <Link to="/" className="flex items-center gap-2.5" data-testid="footer-brand-logo">
            <span className="flex h-10 w-10 items-center justify-center bg-ivory">
              <img src="/assets/logo.png" alt="Cleef Empire logo" className="h-8 w-auto" width="32" height="32" />
            </span>
            <span className="font-display text-xl font-extrabold leading-none tracking-tight">
              <span className="text-cleef">Cleef</span> <span className="text-white">Empire</span>
            </span>
          </Link>
          <p className="mt-5 max-w-xs text-sm leading-relaxed text-white/55">
            Professional uniform manufacturing for businesses worldwide.
          </p>
          <a
            href={waUrl(WA_GENERAL)}
            target="_blank"
            rel="noopener noreferrer"
            data-event="whatsapp_click"
            data-testid="footer-whatsapp-btn"
            className="mt-7 inline-flex items-center gap-2 border border-white/20 px-5 py-3 text-xs font-semibold uppercase tracking-[0.12em] text-white transition-colors duration-300 hover:border-[#25D366] hover:text-[#25D366]"
          >
            <WhatsAppIcon className="h-4 w-4" /> WhatsApp Export Desk
          </a>
        </div>

        <div className="lg:col-span-2">
          <h3 className="font-mono text-[11px] font-semibold uppercase tracking-[0.2em] text-white/40">Quick Links</h3>
          <ul className="mt-5 space-y-3 text-sm">
            {[
              ["Home", "/"],
              ["Industries", "/industries"],
              ["Uniforms", "/uniforms"],
              ["Custom Manufacturing", "/custom-manufacturing"],
              ["Fabric Library", "/fabrics"],
              ["Export", "/export"],
              ["About", "/about"],
              ["Contact", "/contact"],
              ["Bulk Quote", "/bulk-quote"],
            ].map(([label, to]) => (
              <li key={to}>
                <Link to={to} className="text-white/65 transition-colors hover:text-white" data-testid={`footer-link-${label.toLowerCase().replace(/\s+/g, "-")}`}>
                  {label}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div className="lg:col-span-3">
          <h3 className="font-mono text-[11px] font-semibold uppercase tracking-[0.2em] text-white/40">Uniform Categories</h3>
          <ul className="mt-5 space-y-3 text-sm">
            {CATEGORIES.map((c) => (
              <li key={c.slug}>
                <Link to={`/uniforms#${c.slug}`} className="text-white/65 transition-colors hover:text-white">
                  {c.name}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div className="lg:col-span-3">
          <h3 className="font-mono text-[11px] font-semibold uppercase tracking-[0.2em] text-white/40">Contact</h3>
          <ul className="mt-5 space-y-4 text-sm text-white/65">
            <li>
              <a href={`mailto:${SITE.email}`} data-event="email_click" data-testid="footer-email-link" className="group flex items-center gap-3 transition-colors hover:text-white">
                <Mail className="h-4 w-4 shrink-0 text-cleef" /> {SITE.email}
                <ArrowUpRight className="h-3.5 w-3.5 opacity-0 transition-opacity group-hover:opacity-100" />
              </a>
            </li>
            <li>
              <a href={waUrl(WA_GENERAL)} target="_blank" rel="noopener noreferrer" data-event="phone_click" className="flex items-center gap-3 transition-colors hover:text-white">
                <WhatsAppIcon className="h-4 w-4 shrink-0 text-[#25D366]" /> {SITE.whatsappDisplay}
              </a>
            </li>
            <li className="flex items-center gap-3">
              <MapPin className="h-4 w-4 shrink-0 text-cleef" /> {SITE.location}
            </li>
          </ul>
          <p className="mt-6 font-mono text-[11px] uppercase tracking-[0.14em] text-white/35">{SITE.hours}</p>
        </div>
      </div>

      <div className="border-t border-white/10">
        <div className="container-site flex flex-col items-start justify-between gap-3 py-6 text-xs text-white/40 sm:flex-row sm:items-center">
          <p>© {new Date().getFullYear()} Cleef Empire. All Rights Reserved.</p>
          <div className="flex gap-6">
            <Link to="/privacy" className="transition-colors hover:text-white" data-testid="footer-privacy-link">Privacy Policy</Link>
            <Link to="/terms" className="transition-colors hover:text-white" data-testid="footer-terms-link">Terms &amp; Conditions</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
